export default __webpack_public_path__ + "static/LOGO-c7b55ae418ad70692ef1903cb5b5cf1b.svg";